<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Questions Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
				<a href="#" @click="loadQuestionnaireTab()">Questionnaires</a>
				<a href="#" @click="loadQuestionTab()">Questions</a>
				<a href="#" @click="onLoad()" v-if="questionnaire">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="CMS Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>
		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<p class="my-4">{{deleteWarningMessage}}</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="delMethod()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal> 
		<div class="row" v-if="tabIndex === 0">
			<div class="col-md-3 mb-4">
				<h2>Questionnaires</h2>
				<div class="row mb-1" v-for="q in questionnaires" :key="q.id">
					<b-button @click="selectQuestionnaire(q)">{{q.title}}</b-button>
				</div>
				<div class="row mt-2 mb-1">
					<b-button @click="newQuestionnaire()" variant="success"><b-icon-plus font-scale="1.5"/> New Questionnaire</b-button>
				</div>
				<div class="row mb-1" v-if="questionnaire">
					<b-button @click="saveQuestionnaire()" variant="primary"><b-icon icon="check-circle-fill" font-scale="1.5"/> Save Current Questionnaire</b-button>
				</div>
				<div class="row mb-1" v-if="questionnaire">
					<b-button @click="deleteQuestionnairePressed()" variant="danger"><b-icon-trash font-scale="1.5"/> Delete Current Questionnaire</b-button>
				</div> 
			</div>
			<div class="col-md-9" v-if="questionnaire">
				<div class="m-5 mt-0">
					<h2>{{questionnaire.title}}</h2>
					<div class="mb-2"><small>ID: {{questionnaire.id}}</small></div>
					Title: <b-form-input class="mb-2" v-model="questionnaire.title"></b-form-input> 
					Key (use title no spaces): <b-form-input class="mb-2" v-model="questionnaire.key"></b-form-input>
					Tags: <b-form-input class="mb-2" v-model="questionnaire.tags"></b-form-input>
					Is Quiz: <b-form-checkbox class="mb-2" v-model="questionnaire.isQuiz"></b-form-checkbox>
					Submitted text (use %SCORE% for quiz score "x out of y".):<br/>
					<b-form-textarea class="mb-2" v-model="questionnaire.submittedText"></b-form-textarea>
					<div class="col new-question-card m-5 mt-0" v-if="addQuestion">  
						<div v-if="!createNewQuestion">
							<h3>Add a question:</h3>
							<b-row>
								<div class="col-5 text-center">
									<b-row><p>Choose from library:</p></b-row>
									<b-row><b-form-select  v-on:change="addQuestionToQuestionnaire" :options="questions" > </b-form-select></b-row>
								</div>
								<div class="col-2  text-center">
									<p>Or</p>
								</div>
								<div class="col-5  text-center">
									<b-button @click="createQuestionPressed">Create a new question</b-button> 
								</div>
							</b-row> 
						</div>
						<div v-else>
							<h3 v-if="createNewQuestion">New question:</h3>
							<QuestionCard 
								:question="newQuestion" 
								:questionnaireId="questionnaire.id"
								:initEditMode="true"
								@onChange="onLoad" 
								@onError="showError" 
								@onMessage="showMessage" 
								@cancelNewQuestion="handleCancelNewQuestion"
							/>
						</div>
					</div>
					<div v-else class="col">
						<b-button variant="success" @click="addQuestion=true">Add Question</b-button>
					</div>
					<b-row>
						<b-col>Questions ({{questionnaire.questionnaireQuestions.length}}): </b-col>
					</b-row>
					<div 
						v-for="(qq, index) in questionnaire.questionnaireQuestions" 
						:key="qq.questionId"
						draggable
						@dragstart.self="pickupElem($event, qq, index);"
						@dragover.prevent="showDropPlace($event, qq, index);"
						@dragenter.prevent
						@drop="moveElem($event, qq, index);"
						@dragend.prevent="dragEndClear();"
						>
						<QuestionCard 
							:question="qq.question" 
							:questionnaireId="qq.questionnaireId"
							@onChange="onLoad"
							@onError="showError" 
							@onMessage="showMessage"  />
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="tabIndex === 1">
			<b-row class="m-3">
				<b-col><h2>Question Library</h2></b-col>
				<b-col class="text-center"><b-button variant="success" @click="createQuestionPressed">Create a new question<b-icon-plus font-scale="1.5"/></b-button></b-col>
			</b-row>
			<div v-if="createNewQuestion" class="new-question-card m-5 mt-0">
				<h3 v-if="createNewQuestion">New question:</h3>
				<QuestionCard 
					:question="newQuestion" 
					:initEditMode="true"
					@cancelNewQuestion="handleCancelNewQuestion"
					@onCreateNew="handleCreateNewQuestion" 
					@onError="showError" 
					@onMessage="showMessage" 
				/>
			</div>
			<div v-for="q in questions" :key="q.questionId">
				<QuestionCard 
					:question="q.value" 
					@onChange="onLoad" 
					@onError="showError" 
					@onMessage="showMessage" 
				/>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import QuestionCard from "./Widgets/QuestionCard";
export default {
  name: 'Questions',
  components: {
	QuestionCard
  },
  data() {
	return{
		tabIndex: 0,
		questionnaires: null,
		questionnaire: null,
		questions: null,
		addQuestion: false,
		createNewQuestion: false,
		delMethod: null,
		dragedElem: null,
		overElem: null,
		message: null,
		deleteWarningMessage: null,
		error: null, 
	}
  },
  computed: {
	newQuestion () {
		return {
			id: "",
			text: "",
			questionType: 0,
			possibleAnswers: []
		}
	}
  },
  methods: {
	getQuestionnaires: function(){
		this.$http.get(this.$config.ApiUri + "/Questionnaires")
			.then((result) => {
				this.questionnaires = result.data;
				if (this.questionnaires.length > 0) {
					if (this.questionnaire != null) {
						this.questionnaire = this.questionnaires.find(q => q.id == this.questionnaire.id);
					} else {
						this.questionnaire = this.questionnaires[0];
					}
				}
			}
		)
	},
	selectQuestionnaire: function(p) {
		this.addQuestion = false;
		this.createNewQuestion = false;
		this.questionnaire = p;
	},
	newQuestionnaire() {
		this.questionnaire = { 
			"id": "",
			"key": "",
			"title": "",
			"isQuiz": false,
			"submittedText": "",
			"questionnaireQuestions": []
		};
	},
	saveQuestionnaire: function(){
		if (this.questionnaire.id == null || this.questionnaire.id == "") {
			delete this.questionnaire.id;
			this.$http.post(this.$config.ApiUri + "/Questionnaires", this.questionnaire)
				.then((result) => {
					this.questionnaire = result.data;
					this.getQuestionnaires(false);
					this.showMessage("Questionnaire created OK!");
				}
			).catch(() => { this.showError(); });
		}
		else {
			this.$http.put(this.$config.ApiUri + "/Questionnaires/" + this.questionnaire.id, this.questionnaire)
				.then((result) => {
					this.questionnaire = result.data;
					this.getQuestionnaires(false);
					this.showMessage("Questionnaire saved OK!");
				}
			).catch(() => { this.showError(); });
		} 
		this.createNewQuestion = false;
	},
	deleteQuestionnairePressed() {
		this.deleteWarningMessage = "Deleting a questionnaire";
		this.delMethod = this.deleteQuestionnaire;
		this.$bvModal.show('modSure');
	},
	deleteQuestionnaire() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/Questionnaires/" + this.questionnaire.id)
			.then(() => {
				this.questionnaire = null;
				this.getQuestionnaires(true);
				this.showMessage("Questionnaire deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that Questionnaire cannot be deleted. (" + error + ")"); });
	},
	getQuestions: function(){
		this.$http.get(this.$config.ApiUri + "/Questions")
			.then((result) => {
				this.questions = [];
				result.data.forEach((item) => {
					this.questions.push({
						value : item,
						text: item.text
					});
				});
			}
		)
	},
	createQuestionPressed: function() {
		this.createNewQuestion = true;
	},
	handleCancelNewQuestion: function() {
		this.createNewQuestion = false;
	},
	handleCreateNewQuestion: function() {
		this.createNewQuestion = false;
		this.getQuestions();
		if (this.tabIndex == 0) {
			this.getQuestionnaires();
		}
		this.$forceUpdate();
	},
	addQuestionToQuestionnaire: function(item) {
		console.log("add item to questionnaire")
		console.log(item);
		if (this.questionnaire.id != null && this.questionnaire.id != "") {
			if (item.id != null && item.id != "") {
				this.$http.post(this.$config.ApiUri + "/Questionnaires/" + this.questionnaire.id + "/QuestionnaireQuestions/" + item.id)
					.then(() => {
						this.showMessage("added to questionnaire");
						this.addQuestion = false;
						this.createNewQuestion = false;
						this.onLoad();
					}
				).catch((e) => { 
					console.log("Error adding question from questionnaire ");
					console.log(e);
				});
			}
		} 
	},
	loadQuestionnaireTab() {
		this.tabIndex = 0;
		this.addQuestion = false;
		this.createNewQuestion = false;
		this.getQuestionnaires(true);
	},
	loadQuestionTab() {
		this.tabIndex = 1;
		this.addQuestion = false;
		this.createNewQuestion = false;
		this.getQuestions();
	},
	dragEndClear() {
		console.log("dragEnd");
		this.dragedElem = null;
		this.overElem = null;
	},
	pickupElem(event, elem) {
		console.log("pick up elem");
		console.log(elem);
		event.dataTransfer.dropEffect = "move";
		this.dragedElem = { ...elem };
	},
	showDropPlace(event, elem) {
		if (elem.id !== this.dragedElem.id) {
		this.overElem = { ...elem };
		} else {
		this.overElem = null;
		}
	},
	moveElem(event, elem, index) {
		console.log(
		`moveElem: event: ${event} | elem: ${elem} | index: ${index}`
		);
		this.questionnaire.questionnaireQuestions = this.questionnaire.questionnaireQuestions.filter(item => item.questionId !== this.dragedElem.questionId);
		this.questionnaire.questionnaireQuestions.splice(index, 0, { ...this.dragedElem });
		this.questionnaire.questionnaireQuestions.forEach((item, index) => (item.order = index + 1));
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tech"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.createNewQuestion = false;
		this.addQuestion = false;
		this.getQuestionnaires(true);
		this.getQuestions();
		this.$forceUpdate();
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
.question-card {
	padding: 20px;
	margin-bottom: 20px;
	background-color:aliceblue;
}
.new-question-card {
	padding: 20px;
	margin-bottom: 20px;
	background-color:aliceblue;
}
.card2 {
	padding: 20px;
	margin: 20px;
	background-color:white;
}
.activeBtn {
  background: rgb(243, 16, 0) !important;
}
.answerButton {
	background: grey;
	font-size: 4px;
	margin: 2px;
}
.list__elem {
	cursor: row-resize;
	border: 1px solid blue;
	padding: 5px;
	margin-bottom: 5px;
	transition: all 0.3s ease;
}
.list__elem--is-dragged {
	opacity: 0.7;
	border: 1px dashed skyblue;
}
.drop-place {
	position: relative;
	transition: all 0.3s ease;
}
.drop-place--before {
	padding-top: 40px;
}
.drop-place--after {
	padding-bottom: 40px;
}
.drop-place--before:before {
	position: absolute;
	top: 5px;
	left: 0;
	text-align: center;
	content: "Drop here";
	width: 100%;
	padding: 5px 0;
	opacity: 0.7;
	border: 1px dashed skyblue;
	box-shadow: inset 0px 0px 5px 2px skyblue;
}
.drop-place--after:after {
	position: absolute;
	bottom: 5px;
	left: 0;
	text-align: center;
	content: "Drop here";
	width: 100%;
	padding: 5px 0;
	opacity: 0.7;
	border: 1px dashed skyblue;
	box-shadow: inset 0px 0px 5px 2px skyblue;
}
</style>